import { useState, useEffect } from "react"
import Swal from "sweetalert2"
import { formatDate, searchListQuery } from "../../actions/global-actions"
import { useApp } from "../../context/useApp"
import Paginator from "../../components/paginator/paginator"
import { getAwaitingRequests } from "../../actions/request-actions"
import { Link, useSearchParams } from "react-router-dom"
import { setSkipValue } from "../../components/setSkipValue"
import {
  awaitingTableBody,
  awaitingTableHeaders,
} from "./awaiting-requests-data"
import TableComponent from "../../components/table/table"

function AwaitingRequests() {
  const [searchParams, setSearchParams] = useSearchParams()
  const [requests, setRequests] = useState([])
  const [loadData, setLoadData] = useState(true)
  const [isLoadingTable, setIsLoadingTable] = useState(false)
  const { user, setLoading } = useApp()
  const [searchData, setSearchData] = useState(searchParams.get("q") || "")
  const [skip, setSkip] = useState(setSkipValue(searchParams))

  const [paginatorData, setPaginatorData] = useState({
    totalitems: 0,
    totalpages: 0,
    currentpage: 0,
  })

  const currentLink = "/inmuebles"

  useEffect(() => {
    const getFunction = (response) => {
      let data = response.data
      if (data.code === "01") {
        Swal.fire({
          title: "Error",
          confirmButtonColor: "#76b4ff",
          text: data.message,
        })
        setIsLoadingTable(false)
        return
      }
      let requestsArray = []
      data.data.forEach((property) => {
        property.requests.forEach((request) => {
          if (request.status === "Pendiente") {
            request.applicant = `${request.firstName} ${request.lastName} ${request.documentType} No ${request.document}`

            request.property = `${property.code} - ${property.address} B/${property.neighborhood} ${property.city}, ${property.province}`

            if (request.monthlyIncome) {
              request.incomeText = `$${request.monthlyIncome
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`
            } else {
              switch (request.userType) {
                case "Empleado":
                  request.incomeText = `$${request.employee.salary
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`
                  break
                case "Independiente":
                  request.incomeText = `$${request.independent.income
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`
                  break
                case "Pensionado":
                  request.incomeText = `$${request.pensionary.value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`
                  break
                default:
                  request.alertClass = true
                  request.alertItem = "userTypeText"
                  request.incomeText = "Pendiente"
                  break
              }
            }
            request.userTypeText = request.userType
              ? request.userType
              : "Pendiente"
            request.formattedDate = formatDate(request.createdAt, 4)
            const seeLink = `${currentLink}/${property._id}/solicitud/${request._id}`
            const editLink = `${currentLink}/${property._id}/solicitud/${request._id}/editar`
            request.link = seeLink
            request.editLink = editLink
            requestsArray.push(request)
          }
        })
      })

      setRequests(requestsArray)

      setPaginatorData({
        ...paginatorData,
        ...response.headers,
      })
      setIsLoadingTable(false)
    }

    if (loadData) {
      setLoadData(false)
      setRequests([])
      setIsLoadingTable(true)
      ;(async () => {
        try {
          let result
          if (searchData.length > 2) {
            result = await searchListQuery(
              "property/get-awaiting-requests",
              searchData,
              setLoading,
              skip,
              user.token,
            )
          } else {
            result = await getAwaitingRequests(skip, setLoading, user.token)
          }
          getFunction(result)
        } catch (error) {
          console.error("Error fetching requests:", error)
          setIsLoadingTable(false)
        } finally {
          setLoading(false)
        }
      })()
    }
  }, [loadData, user.token, skip, paginatorData, searchData, setLoading])

  return (
    <div className="w-100 d-flex">
      <div className="container d-flex flex-column">
        <h1 className="my-5">Solicitudes pendientes por revisar</h1>
        <div className="mt-3">
          <span className="align-self-center">
            Solicitudes: <b>{paginatorData.totalitems}</b>
          </span>
        </div>
        <TableComponent
          id={"awaiting-table"}
          headers={awaitingTableHeaders}
          body={awaitingTableBody}
          skip={skip}
          data={requests}
          link={``}
          needOptions={true}
          showViewIcon={true}
          isLoading={isLoadingTable}
        />
        {paginatorData.totalpages > 0 && paginatorData.currentpage > 0 && (
          <Paginator
            skip={skip}
            data={paginatorData}
            setSkip={(n) => setSkip(n)}
            setLoadData={(need) => setLoadData(need)}
            queryParams={searchParams}
            setQueryParams={(params) => setSearchParams(params)}
          />
        )}
      </div>
    </div>
  )
}

export default AwaitingRequests
